import { useMemo } from "react";
import { useForm } from "@shared/features/form/useForm";
import { Form } from "@shared/features/form/Form";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import { baseAccountSchema } from "@shared/schemas/sharedSchemas";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { useAccountMutation } from "../../hooks/useAccountMutation";
import { User } from "@platform/types/platform.types";

export type Props = {
  user: User | null;
};

export function SettingsAccountForm({ user }: Props) {
  const schema = baseAccountSchema;

  const fields = makeFormFields(["email", "password"]).map((field) => {
    if (field.name === "password") {
      return {
        ...field,
        isHideErrorMessage: false,
        layout: "horizontal",
        autoComplete: "current-password",
      };
    }
    return { ...field, layout: "horizontal" };
  });

  const onSuccess = (data: any) => {};

  const accountMutation = useAccountMutation({
    onSuccess,
    schema,
    currentEmail: user?.email || "",
  });

  const defaultValues = useMemo(() => {
    return {
      email: user?.email ?? "",
      password: "",
    };
  }, [user]);

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: accountMutation.mutateAsync,
    defaultValues,
  });

  const handleCancel = () => {
    form.reset();
  };

  const { isSubmitting, isLoading, isValid, isDirty } = form.formState;

  return (
    <div className="flex flex-col gap-4 w-full">
      <Form
        fields={fields}
        form={form}
        errorContainerClassName="p-0 w-full max-w-full mt-8"
      />
      <ActionButtonsGroup
        primaryButtonText={"Update Email"}
        onPrimaryClick={handleSubmit}
        secondaryButtonText={isDirty ? "Cancel" : undefined}
        onSecondaryClick={isDirty ? handleCancel : undefined}
        className="size-max w-fit self-end"
        primaryButtonProps={{
          disabled: !isDirty || !isValid || isSubmitting || isLoading,
        }}
      />
    </div>
  );
}

export default SettingsAccountForm;
